import {
  useGetInitialFiltersFromUrl,
  useGetSortFromUrl,
  useGetPaginationFromUrl,
  useGetFiltersUrl,
} from 'shared/lib/hooks';

import { ManagerCampaignsFilter, ManagerCampaignsSort } from '../model';

export const useGetCampaignManagerFilters = () => {
  const filters = useGetInitialFiltersFromUrl({
    filterKeys: ManagerCampaignsFilter,
    keysWithFromTo: [ManagerCampaignsFilter.budgetSpentFromTo],
  });
  const sorting = useGetSortFromUrl(ManagerCampaignsSort);
  const pagination = useGetPaginationFromUrl();
  const { filtersFromURL } = useGetFiltersUrl({
    urlFilters: [filters, pagination, sorting],
  });

  return filtersFromURL;
};
